<template>
    <span>
        <select @click="$emit('click', $event)" v-model="gengoIndex" class="select w4_0em mr8" :class="{ 'error': isInvalid }" :disabled="isDisabled">
            <option></option>
            <option v-for="(gengo,index) in gengoData" :key="index" :value="index" v-text="gengo.text"></option>
        </select>
        <select @click="$emit('click', $event)" v-model="gengoYear" class="select w4_0em" :class="{ 'error': isInvalid }" :disabled="isDisabled">
            <option></option>
            <option v-for="index in maxGengoYear" :key="index" :value="index" v-text="year(index)"></option>
        </select>
    </span>
</template>

<script>

export default {
  name: 'WarekiInputFromH',
  props: {
    value: {
      type: Number,
      default: 0
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      gengoIndex: '0',
      gengoYear: 0,
      gengoData: [
        { text: '平成', base: 1988, max: 33 },
        { text: '令和', base: 2018, max: 30 }
      ]
      // initialized: false
    }
  },
  methods: {
    calcYear: function () {
      let year = null
      if (this.hasGengo && this.gengoYear > 0) {
        const gengo = this.gengoData[this.gengoIndex]
        year = this.gengoYear + gengo.base
      }
      this.$emit('input', year)
    },
    firstGetGengo: function (date) {
      this.gengoYear = this.toWarekiFromH(date).year
      this.gengoIndex = this.toWarekiFromH(date).gengonumber + ''
      // this.initialized = false
    },
    year: function (i) {
      // 元年ではなくて1年で対応
      /*
      if (i === 1) {
        return '元'
      }
      */
      return i
    }
  },
  computed: {
    hasGengo: function () {
      return (this.gengoData[this.gengoIndex] !== undefined)
    },
    selectingGengo: function () {
      return (this.hasGengo)
        ? this.gengoData[this.gengoIndex]
        : null
    },
    maxGengoYear: function () {
      return (this.hasGengo)
        ? this.selectingGengo.max
        : 0
    }
  },
  mounted: function () {
    if (this.value > 0) {
      for (const i in this.gengoData) {
        const gengo = this.gengoData[i]
        if (this.value > gengo.base) {
          this.gengoIndex = i
          this.gengoYear = this.value - gengo.base
        }
      }
    }
    // var self = this
    // Vue.nextTick(function () {
    //   self.initialized = true
    // })
  },
  watch: {
    gengoIndex: function () {
      // if (this.initialized && this.hasGengo) {
      //   this.gengoYear = 0
      // }
      this.calcYear()
    },
    gengoYear: function () {
      this.calcYear()
    }
  }
}
</script>
